import React, { useContext } from 'react';
import { Navigate } from "react-router-dom";
import { AuthContext } from '../../context/AuthContext';

export const ProtectedRoute = ({ children }) => {

    const { user } = useContext(AuthContext);

    if (user && user !== 'null') {
        return children; 
    }

    return <Navigate to="/" replace />;
};

export const ProtectedRouteAdmin = ({ children }) => {
    const { user } = useContext(AuthContext);
    
    if (user) {
        if (user.role === 'admin') {
            return children; 
        }
    }

    return <Navigate to="/" replace />;
};